export default __webpack_public_path__ + "static/media/Background_00047.98d641a2.png";